import { Component } from '@angular/core';

@Component({
  selector: 'app-seriesheader',
  templateUrl: './seriesheader.component.html',
  styleUrls: ['./seriesheader.component.scss']
})
export class SeriesheaderComponent {

}
